// Mobile filter pop up
function showFilter() {

  if($(window).width() > 980){
    $('.collection-filters').show();
    $('#sortDropdown').show();
  }
}

function growShrinkLogo() {
  if (document.body.scrollTop > 5 || document.documentElement.scrollTop > 5) {
    // $('#logo img').width(120);
    $('#logo img').width(175);
    $('.header-section #identity #logo').css({'margin-top': ''});
  } else {
    $('#logo img').width(175);
    // $('.header-section #identity #logo').css({'margin-top': '0px'});
  }
  if($(window).width() < 979){
    $('.header-section #identity #logo').css({'margin-top': ''});
  }
  $(window).resize(function() {
    if($(window).width() < 979){
      $('#logo img').css({ 'width' : ''});
      $('.header-section #identity #logo').css({'margin-top': ''});
    }
  })
}


// HEADER FIXED
$(window).scroll(function(e){
  if ($(window).scrollTop() >=1) {
    $('#shopify-section-header').addClass('fixed-header').addClass('isStuck');
    $('#top-bar').fadeOut().addClass('hide');
      var headerHeight = $('#shopify-section-header').height();
  $('.header_holder').height(headerHeight);
  }
  else {
    $('#shopify-section-header').removeClass('fixed-header').removeClass('isStuck');
    $('#top-bar').fadeIn().removeClass('hide');
      var headerHeight = $('#shopify-section-header').height();
  $('.header_holder').height(headerHeight);
  }
  growShrinkLogo();
});


$(document).ready(function(){

  //Smooth scrolling to links
  $('a[href*="marker"]').on('click', function(event){
    event.preventDefault();

    $('html, body').animate({
      scrollTop: $( $.attr(this, 'href') ).offset().top
    }, 500);
  });

  // Hover state for header on Home Page
  $('.template-index li.dropdown.has_sub_menu').hover(function(){
    $('#shopify-section-header').addClass('home_header_bg');
  }, function(){
    $('#shopify-section-header').removeClass('home_header_bg');
  })

  // Creates container the same height as navigation to ensure smoother scroll when the navigation position is changed to fixed
  var h = $('#shopify-section-header').height();
  var topBar = $('#top-bar').height();

	$('#shopify-section-header').wrap( "<div class='header_holder'></div>" );
	$('.header_holder').height(h);

  $("#closebanner").click(function() {
    $('#shopify-section-header').wrap( "<div class='header_holder'></div>" );
    $('.header_holder').height(h - topBar);
  });

  if (window.location.href.indexOf("/apps/sitemap") > -1) {
    console.log('sitemap');
    $('body').addClass('rs-sitemap');
  }

  // // Adds Tops subnav in navigation
  // // Clothing
  $('li.dropdown.has_sub_menu:nth-of-type(2) ul.mega-stack li, li.dropdown.has_sub_menu:nth-of-type(2) ul li span, #accordion .accordion-content:nth-of-type(1) .accordion-content2 li').each(function(){
    if($(this).text() == 'Tops'){
      $(this).append(
        '<ul class="list_subnav">' +
        '<span class="ion-chevron-right"></span><a href="/collections/tanks"><li>Tanks</li></a>' +
        '<span class="ion-chevron-right"></span><a href="/collections/tunics"><li>Tunics</li></a>' +
        '<span class="ion-chevron-right"></span><a href="/collections/blouses"><li>Blouses</li></a>' +
        '</ul>'
      );
      //Toggle Tops dropdown
      $(this).on('click', function(e){
      		if($(this).find('.list_subnav').is(':visible')){
            console.log('if click');
          }
      		else {
            console.log('else click');
      			e.preventDefault();
            $(this).find('.list_subnav').addClass('open').on('touchstart mouseenter focus', function(e){
    					if(e.type == 'touchstart') {
    						e.stopImmediatePropagation();
    					}
    			  });
      		}
      })
    }
  });
  // Plus Size
  $('li.dropdown.has_sub_menu:nth-of-type(3) ul.mega-stack li, li.dropdown.has_sub_menu:nth-of-type(3) ul li span, #accordion .accordion-content:nth-of-type(2) .accordion-content2 li').each(function(){
    if($(this).text() == 'Tops'){
      $(this).append(
        '<ul class="list_subnav">' +
          '<span class="ion-chevron-right"></span><a href="/collections/plus-size-tanks"><li>Tanks</li></a>' +
          '<span class="ion-chevron-right"></span><a href="/collections/plus-size-tunics"><li>Tunics</li></a>' +
          '<span class="ion-chevron-right"></span><a href="/collections/plus-size-blouses"><li>Blouses</li></a>' +
        '</ul>'
      );
      //Toggle Tops dropdown
      $(this).on('click', function(e){
      		if($(this).find('.list_subnav').is(':visible')){
            console.log('if click');
          }
      		else {
            console.log('else click');
      			e.preventDefault();
            $(this).find('.list_subnav').addClass('open');
            $(this).find('.list_subnav').on('touchstart mouseenter focus', function(e){
    					if(e.type == 'touchstart') {
    						e.stopImmediatePropagation();
    					}
    			  });
      		}
      })
    }
  });
  $('#accordion .accordion-content:nth-of-type(2) .accordion-toggle2').html('Types');

  // Women Sales
  // $('li.dropdown.has_sub_menu:nth-of-type(7) .mega-container li.desktop-3:nth-of-type(1) li, li.dropdown.has_sub_menu:nth-of-type(7) .mega-container li.textSale:nth-of-type(1) li, #accordion .accordion-content:nth-of-type(3) .accordion-content2:nth-of-type(2) li').each(function(){
  //   if($(this).text() == 'Tops') {
  //     $(this).append(
  //       '<ul class="list_subnav">' +
  //       '<span class="ion-chevron-right"></span><a href="/collections/tanks-sale"><li>Tanks</li></a>' +
  //       '<span class="ion-chevron-right"></span><a href="/collections/tunics-sale"><li>Tunics</li></a>' +
  //       '<span class="ion-chevron-right"></span><a href="/collections/blouses-sale"><li>Blouses</li></a>' +
  //       '</ul>'
  //     );
  //     //Toggle Tops dropdown
  //     $(this).on('click', function(e){
  //     		if($(this).find('.list_subnav').is(':visible')){
  //           console.log('if click');
  //         }
  //     		else {
  //           console.log('else click');
  //     			e.preventDefault();
  //           $(this).find('.list_subnav').addClass('open');
  //           $(this).find('.list_subnav').on('touchstart mouseenter focus', function(e){
  //   					if(e.type == 'touchstart') {
  //   						e.stopImmediatePropagation();
  //   					}
  //   			  });
  //     		}
  //     })
  //   }
  // });

  // Plus Size Sales
  $('li.dropdown.has_sub_menu:nth-of-type(7) .mega-container li.desktop-3:nth-of-type(2) li, li.dropdown.has_sub_menu:nth-of-type(7) .mega-container li.textSale:nth-of-type(2) li, #accordion .accordion-content:nth-of-type(3) .accordion-content2:nth-of-type(4) li').each(function(){
    if($(this).text() == 'Tops'){
      $(this).append(
        '<ul class="list_subnav">' +
          '<span class="ion-chevron-right"></span><a href="/collections/plus-size-tanks-sale"><li>Tanks</li></a>' +
          '<span class="ion-chevron-right"></span><a href="/collections/plus-size-tunics-sale"><li>Tunics</li></a>' +
          '<span class="ion-chevron-right"></span><a href="/collections/plus-size-blouses-sale"><li>Blouses</li></a>' +
        '</ul>'
      );
      //Toggle Tops dropdown
      $(this).on('click', function(e){
      		if($(this).find('.list_subnav').is(':visible')){
            console.log('if click');
          }
      		else {
            console.log('else click');
      			e.preventDefault();
            $(this).find('.list_subnav').addClass('open').on('touchstart mouseenter focus', function(e){
    					if(e.type == 'touchstart') {
    						e.stopImmediatePropagation();
    					}
    			  });
      		}
      })
    }
  });

  // $('li.dropdown.has_sub_menu .mega-container li, #accordion .accordion-content li').each(function(){
  // if($('li.dropdown.has_sub_menu a:contains("Plus")').length > 0){
  //   $(this).css({'border':'1px solid red', 'display':'inline-block'});
  //   console.log('Plus');
  // }


  // $('li.dropdown.has_sub_menu .mega-container li, #accordion .accordion-content li').each(function(){
  //   if($(this).text() == 'Tops'){
  //
  //     // Need to account for plus subnav in Sale
  //
  //     // if the main nav item is Plus or the submenu title for Sales is Plus then add links for plus tops
  //     if ($(this).parents('.has_sub_menu').text().indexOf('Plus') > -1 ){
  //     // if(($(this).parents('.has_sub_menu').text().indexOf('Plus') > -1) || ($(this).parents('.has_sub_menu').find('h4').text().indexOf('Plus') > -1) ){
  //     // if(($(this).parents('.has_sub_menu').text().indexOf('Plus') > -1) || ($(this).closest('h4').text().indexOf('Plus') > -1) ){
  //     // if ($(this).closest('h4 a').text().indexOf('Plus') > -1){
  //       console.log('plus');
  //       $(this).css({'border':'1px solid red'});
  //       $(this).append(
  //         '<ul class="list_subnav">' +
  //         '<a href="/collections/tanks-plus"><li>Tanks</li></a>' +
  //         '<a href="/collections/tunics-plus"><li>Tunics</li></a>' +
  //         '<a href="/collections/blouses-plus"><li>Blouses</li></a>' +
  //         '</ul>'
  //       )
  //     } else {
  //       // else add links for regular tops
  //       console.log('regular');
  //       $(this).css({'border':'1px solid blue'});
  //       $(this).append(
  //         '<ul class="list_subnav">' +
  //         '<a href="/collections/tanks"><li>Tanks</li></a>' +
  //         '<a href="/collections/tunics"><li>Tunics</li></a>' +
  //         '<a href="/collections/blouses"><li>Blouses</li></a>' +
  //         '</ul>'
  //       );
  //     }
  //     $(this).on('click', function(e){
  //       if($(this).find('.list_subnav').is(':visible')){
  //         console.log('if click');
  //       }
  //       else {
  //         console.log('else click');
  //         e.preventDefault();
  //         $(this).find('.list_subnav').addClass('open');
  //         $(this).find('.list_subnav').on('touchstart mouseenter focus', function(e){
  //           if(e.type == 'touchstart') {
  //             e.stopImmediatePropagation();
  //           }
  //         });
  //       }
  //     })
  //
  //
  //   }
  // });


  // Remove click through on "Shop the Collection"
  $('li.dropdown.has_sub_menu:nth-of-type(2) li.desktop-6.tablet-fourth:nth-of-type(2) h4 a').attr("href", "javascript:void(0);");

  if($('body').hasClass('collection')){
    // Filter popup PLP
    $('.filter-mobile').on('click',function(){
      $('.collection-filters, .bg-overlay').toggle();
    });

    // Prevent page scroll on mobile when mobile filter is opened
    $('.collection #full-width-filter .filter-mobile').on('click', function(){
      $('.overflow_container').addClass('noscroll');
    })
    showFilter();
  }


  if($('body').hasClass('template-search')){
    // Filter popup search
    $('.filter-mobile').on('click',function(){
      $('.collection-filters, .bg-overlay').toggle();
    });
    showFilter();
  }



  if($('body').hasClass('product')){
    // Hide Color Options by Panda Swatches
    $('.product .panda-swatches-cont').each(function(i,o){
       if($(o).find('label').text().trim() == 'Color'
         && $(o).find('.panda-swatch').length == 1) {
         $(this).hide();
       }
     })

   setTimeout(function(){
     // Change position of Limespot - Complete The Look
     $('limespot').remove();
     $('limespot').addClass('moved');
     $('#shopify-product-reviews').before($("limespot.moved"));

     // Change position of Nosto - Complete The Look
     $('#productpage-nosto-2').addClass('moved');
     $('#shopify-product-reviews').before($("#productpage-nosto-2.moved"));
   }, 500);


    // Get saved data from PLP on localStorage
	if (localStorage.getItem("coll_handle") !== null) {
      var coll_handle = localStorage.getItem('coll_handle').replace(/-/g, ' ');
      var coll_handle_link = localStorage.getItem('coll_handle');
    }

   // Adjust the breadcrumb text and link to reference the previous collection the user was redirected from
	if (localStorage.getItem("coll_handle") !== null) {
      $('.pdp_coll_handle').text(coll_handle);
      $('.pdp_coll_handle').parent().attr('href', 'https://www.misook.com/collections/'+ coll_handle_link)
      $('.pdp_coll_handle').parent().attr({
        href:'https://www.misook.com/collections/'+ coll_handle_link,
        id:'https://www.misook.com/collections/'+ coll_handle_link
      });
    }
  }


  // ACCOUNT - ADJUST STYLING OF EDIT ADDRESS FORM
    $('#addresses.customers-addresses .action_edit').click(function(){
      $(this).closest('.address_table').addClass('edit-address');
    });

    $('.edit_address .action_bottom').click(function(){
   	$(this).closest('.address_table').removeClass('edit-address');
    });


  // ACCOUNT - HIDE ADD ADDRESS BUTTON WHEN CLICKED
    $('.customers-addresses .action_add').click(function(){
    	$(this).hide();
    });

    $('#address_form_new .action_bottom').click(function(){
    	$('.customers-addresses .action_add').show();
    });
	
	$("#address_country_new").val($("#address_country_new option:first-child").text());
	$("#address_country_new option[value='---']").attr("value", "");

});


// Show filter when resizing browser from mobile
$(window).resize(function() {
  if($('body').hasClass('collection')){
    showFilter();
  }

  //To ensure smooth scrolling when header is set to position fixed
  var headerHeight = $('#shopify-section-header').height();
  $('.header_holder').height(headerHeight);
});



// Page Fade In
$( window ).on( "load", function() {
  $('#content, .index-sections, .scrollup, #shopify-section-footer').addClass('revealed');
});



/**
 * Show Error
 *
 * @param errorText
 */
function showError(errorText, input) {
	$(input).parent("td").append('<p class="error" style="margin: -15px 0 0; color: #a94442">' + errorText + '</p>');
}

function errorClass(type, div, errorMessage) {
	if(type != '') {
		if(type == 'add') {
			jQuery(div).parent().addClass('has-error');
			$(".has-error:first input").focus();
			if(errorMessage) {
				showError(errorMessage, div);
			}
		} else if(type == 'remove') {
			jQuery(div).parent().removeClass('has-error');
		}
	} else {
		jQuery('.has-error').removeClass('has-error');
	}
}


function validateForm(formData) {
	let result = true;
	errorClass('');
	$('#add_address' + " .error").remove();
	const requiredFields = jQuery(formData + ' .required');
	if (requiredFields.size() > 0) {
		requiredFields.each(function () {
			if (jQuery(this).attr("name") && jQuery(this).is(':visible') && jQuery.trim(jQuery(this).val()) == '') {
				errorClass('add', this, "");
				result = false;
			}
		});
	}
	
	var zipCodeDiv = jQuery(formData + ' .validate-zip');
	var zipCodeSize = zipCodeDiv.size();
	if(zipCodeSize > 0) {
		zipCodeDiv.each(function() {
			var zipCode = jQuery(this).val();
			if(zipCode != '') {
				if(!validateZipCode(zipCode)) {
					errorClass('add', jQuery(this), jQuery(this).attr('data-placeholder') + ' is Invalid');
					result = false;
				}
			}
		});
	}
	
	var phoneDiv = jQuery(formData + ' .validate-phone');
	var phoneSize = phoneDiv.size();
	if(phoneSize > 0) {
		phoneDiv.each(function() {
			var phone = jQuery(this).val();
			if(phone != '') {
				if(!validatePhone(phone)) {
					errorClass('add', jQuery(this), jQuery(this).attr('data-placeholder') + ' is Invalid');
					result = false;
				}
			}
		});
	}
	
	var cityDiv = jQuery(formData + ' .validate-city');
	var citySize = cityDiv.size();
	if(citySize > 0) {
		cityDiv.each(function() {
			var city = jQuery(this).val();
			if(city != '') {
				if(!validateCityVal(city)) {
					errorClass('add', jQuery(this), jQuery(this).attr('data-placeholder') + ' is Invalid');
					result = false;
				}
			}
		});
	}
	
	return result;
}

/**
 * Validate Zip code
 *
 * @param zipCode
 * @returns {boolean}
 */
function validateZipCode(zipCode) {
	var pattern = /[^\w\s-]/gi;
	
	return !pattern.test(zipCode);
}

/**
 * Validate Phone Number
 *
 * @param number
 * @returns {boolean}
 */
function validatePhone(number) {
	if (number.length > 1) {
		var regexObj = /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/;
		if (regexObj.test(number)) {
			return true;
		}
	}
	return false;
}


function validateCityVal(city) {
	var regexObj = /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/;
	
	if (regexObj.test(city)) {
		return true;
	}
	return false;
}

jQuery(document).on("submit", "#address_form_new", function() {
	jQuery(".alert-success, .alert-danger").html('');
	if (!validateForm("#address_form_new")) {
		
		return false;
	}
});